<div class="edit-role-connection row gx-3 gy-1"
     [class.gy-lg-0]="isAdding"
     [class.gy-lg-3]="!isAdding">
    <div class="column-role"
         [class.col-lg-4]="isAdding"
         [class.col-lg-12]="!isAdding">
        @switch (model.identifier) {
            @case ("role") {
                <label>Role</label>
                <adapt-select-role [role]="roleConnection?.role"
                                   [required]="true"
                                   [readonlyModeOnSelection]="true"
                                   [filter]="roleFilter"
                                   [allowCulturalLeaderRoles]="false"
                                   (roleChange)="roleConnection!.role = $event; onChanged()"></adapt-select-role>
            }
            @case ("person") {
                <label>Person</label>
                <div>
                    @if (roleConnection?.connection) {
                        <adapt-link-person [person]="roleConnection?.connection?.person"
                                           [linkDisabled]="true"
                                           [showImage]="true"></adapt-link-person>
                    } @else {
                        <adapt-select-person data-test="select-role-person"
                                             [required]="true"
                                             [person]="roleConnection?.connection?.person"
                                             (personChange)="onPersonChanged($event)"
                                             [filter]="connectionFilter"></adapt-select-person>
                    }
                </div>
            }
        }
    </div>

    <div class="column-start-date col-lg-4">
        <label>Start date</label>
        <dx-date-box class="date-cell-content"
                     [min]="minStartDate"
                     [max]="maxStartDate"
                     [value]="roleConnection?.startDate ?? null"
                     (valueChange)="onStartDateChanged($any($event))"></dx-date-box>
    </div>

    @if (!isAdding) {
        <div class="column-end-date col-lg-4">
            @if (showEndDate) {
                <label>End date</label>
                <dx-date-box class="date-cell-clear-content"
                             [value]="roleConnection?.endDate ?? null"
                             (valueChange)="onEndDateChanged($any($event))"
                             [min]="minEndDate"
                             [max]="maxEndDate"
                             [showClearButton]="!endDateRequired"
                             [opened]="endDateOpened"></dx-date-box>
            } @else {
                <div [adaptTooltip]="endConnectionDisableMessage">
                    <button adaptButtonIcon="clear"
                            class="btn btn-primary"
                            [disabled]="!roleConnection?.role || !roleConnection?.connection || !canEndConnection || startDateInFuture"
                            (click)="endRoleConnection()">End role connection</button>
                </div>
            }
        </div>
    }

    <div class="col-lg-4">
        @if (isAdding) {
            <div class="role-connection-action">
                @if (roleConnection?.entityAspect?.entityState?.isAdded()) {
                    <button adaptButton="cancel"
                            (click)="onDeletion()"></button>
                } @else if (roleConnection?.isInactive()) {
                    <button adaptButton="delete"
                            (click)="promptToDeleteRoleConnection()"></button>
                }
            </div>
        } @else {
            @if (showEndDate || roleConnection?.isInactive()) {
                <button adaptButton="delete"
                        (click)="promptToDeleteRoleConnection()"></button>
            } @else {
                <!-- placeholder to take up same height since no button -->
                <button adaptButton="delete"
                        class="invisible"></button>
            }
        }
    </div>

    @if (!isAdding && !showEndDate) {
        <div class="col-lg-4">
            <label>Handover status
                <i class="fal fa-info-circle ms-1"
                   adaptTooltip="Indicates the current stage of a person's role transition, whether they are currently handing this role off, planning to hand this role off, or beginning this role."></i>
            </label>
            <dx-select-box [dataSource]="HandoverStatuses"
                           displayExpr="name"
                           [showClearButton]="false"
                           [value]="roleConnection?.handoverStatus ? HandoverByStatus[roleConnection!.handoverStatus!] : HandoverStatuses[0]"
                           (valueChange)="onHandoverStatusChange($any($event))"></dx-select-box>
        </div>
    }
</div>
